import { StyleProp, TextStyle, ViewStyle } from 'react-native';
import { ImageStyle } from 'react-native-fast-image';
import { useResponsiveContext } from '../../functions/responsive/ResponsiveContext';

export type SnackbarStyles = {
  bar?: StyleProp<ViewStyle>;
  contentContainer?: StyleProp<ViewStyle>;
  imageContainer?: StyleProp<ViewStyle>;
  image?: StyleProp<ImageStyle>;
  text?: StyleProp<TextStyle>;
  closeButton?: { size?: number; color?: string; style?: StyleProp<ViewStyle> };
};

type Preset = 'default';

export const useSnackbarStylePresets = (): {
  [p in Preset]: SnackbarStyles;
} => {
  const { rpx } = useResponsiveContext();
  return {
    // default snackbar styles
    default: {
      contentContainer: {
        paddingLeft: rpx(15),
        paddingRight: rpx(15),
        paddingTop: rpx(4),
        paddingBottom: rpx(4),
      },
      imageContainer: {
        alignItems: 'center',
        justifyContent: 'center',
        marginRight: rpx(15),
      },
      image: {
        width: rpx(34),
        height: rpx(34),
        borderRadius: rpx(4),
      },
      closeButton: {
        size: rpx(12),
        color: '#777',
        style: {
          width: rpx(20),
          height: rpx(20),
          borderRadius: rpx(20),
          marginLeft: rpx(15),
          backgroundColor: '#CCC',
          justifyContent: 'center',
          alignItems: 'center',
        },
      },
    },
  };
};
